import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup'; // @ts-expect-error importing from JS file

import KnowledgeBaseLink from 'AdsUI/components/KnowledgeBaseLink'; // @ts-expect-error importing from JS file

import { KBArticles } from 'AdsUI/lib/Constants';

/**
 * The "Data sharing" event field.
 */
const DataSharing = ({
  allowWithoutAdInteraction,
  handleSelect,
  showTitle = true
}) => {
  return /*#__PURE__*/_jsx(UIFormControl, {
    "data-test-id": "data-sharing-field",
    label: showTitle && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "events.creation.CRM_EVENT.dataSharing.fieldLabel"
    }),
    help: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "events.creation.CRM_EVENT.dataSharing.fieldHelpText"
      }), /*#__PURE__*/_jsx(UIHelpIcon, {
        className: "m-left-1",
        title: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "events.creation.CRM_EVENT.dataSharing.fieldHelpTooltipText"
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(KnowledgeBaseLink, {
              kbArticle: KBArticles.SYNC_FB_CONVERSION_EVENTS,
              context: "data-sharing-event-panel"
            })
          })]
        }),
        tooltipPlacement: "top right"
      })]
    }),
    children: /*#__PURE__*/_jsxs(UIToggleGroup, {
      name: "dataSharing",
      children: [/*#__PURE__*/_jsx(UIRadioInput, {
        checked: allowWithoutAdInteraction,
        onChange: () => handleSelect(true),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "events.creation.CRM_EVENT.dataSharing.allowWithoutAdInteraction"
        })
      }, "allowWithoutAdInteraction"), /*#__PURE__*/_jsx(UIRadioInput, {
        className: "m-top-2",
        checked: !allowWithoutAdInteraction,
        onChange: () => handleSelect(false),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "events.creation.CRM_EVENT.dataSharing.onlyAllowWithAdInteraction"
        })
      }, "onlyAllowWithAdInteraction")]
    })
  });
};

export default DataSharing;